var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',[_c('expand-collapse',{attrs:{"expanded":_vm.expanded},on:{"toggle":function($event){return _vm.$emit('toggle')}}}),_vm._v("\n  "+_vm._s(_vm.title)+"\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c2fbdc4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utilities/header-with-toggle.vue
// module id = DvC0
// module chunks = 0